import React, { useState } from "react";
import { Modal } from "antd";
import { Select, Space } from "antd";
import { Icon } from "@iconify/react";

const EditdocpatternModal = ({ iseditModalOpen, setiseditModalOpen }) => {
  const [isChecked, setIsChecked] = useState(false);

  const campaigndata = [
    {
      id: 1,
      doctype: "Test Doc Type 3 Public",
      groupname: "Group Test Public 24",
      pattername: "Test Pattern G 22",
      pattern: "\b[1]{1,1}\b",
    },
    {
      id: 2,
      doctype: "Test Doc Type 3 Public",
      groupname: "Group Test Public 24",
      pattername: "Test Pattern G 22",
      pattern: "\b[1]{1,1}\b",
    },
    {
      id: 3,
      doctype: "Test Doc Type 3 Public",
      groupname: "Group Test Public 24",
      pattername: "Test Pattern G 22",
      pattern: "\b[1]{1,1}\b",
    },
  ];
  const handleCheckboxChange = () => {
    setIsChecked(!isChecked);
  };
  const handleOk = () => {
    setiseditModalOpen(false);
  };
  const handleCancel = () => {
    setiseditModalOpen(false);
  };
  return (
    <>
      <div>
        <Modal
          open={iseditModalOpen}
          onOk={handleOk}
          onCancel={handleCancel}
          className="addpattern-modal"
          centered={true}
          width="70%"
        >
          <form>
            <div className="modal-content">
              <h2 className="fw-bold text-medium-black text-center mt-5">
                Add / Edit Document Type
              </h2>
              <div className="template-div  flex-column mt-5">
                <div className="edit-profile-main d-flex flex-column gap-3">
                  <div className="edit-container d-flex  gap-5 ">
                    <div className="edit-profile-inner d-flex flex-column gap-3">
                      <h5>Select Document Type</h5>
                      <Space wrap>
                        <Select
                          defaultValue="Select Document Type"
                          style={{ width: 317 }}
                          options={[
                            { value: "Document 1", label: "Document 1" },
                            { value: "Document 2", label: "Document 2" },
                            { value: "Document 3", label: "Document 3" },
                          ]}
                        />
                      </Space>
                      <div className="check-me-div d-flex gap-2 mt-2">
                        <input
                          type="checkbox"
                          id="customCheckboxSelectAll"
                          style={{ display: "none" }}
                          checked={isChecked}
                          onChange={handleCheckboxChange}
                        />
                        <label
                          htmlFor="customCheckboxSelectAll"
                          className="customCheckboxLabel"
                        >
                          <span
                            className="customCheckboxTick"
                            style={{
                              background: isChecked
                                ? "#435AB8 "
                                : "transparent",
                            }}
                          >
                            {isChecked && (
                              <span>
                                <Icon
                                  icon="tabler:check"
                                  width={20}
                                  height={18}
                                  color="#FFFFFF"
                                />
                              </span>
                            )}
                          </span>
                        </label>
                        <label className="elarge "> Public group</label>
                      </div>
                      <div className=" justify-content-end d-flex">
                        <button className="modal-dark-btn">Add</button>
                      </div>
                    </div>
                    <div className="edit-profile-inner d-flex flex-column gap-3">
                      <h5>Select Group</h5>
                      <Space wrap>
                        <Select
                          defaultValue="Select Group Type"
                          style={{ width: 317 }}
                          options={[
                            { value: "Group 1", label: "Group 1" },
                            { value: "Group 2", label: "Group 2" },
                            { value: "Group 3", label: "Group 3" },
                          ]}
                        />
                      </Space>
                    </div>
                    <div className="edit-profile-inner d-flex flex-column gap-3">
                      <h5>Select Pattern</h5>
                      <Space wrap>
                        <Select
                          defaultValue="Select Pattern"
                          style={{ width: 317 }}
                          options={[
                            { value: "Pattern 1", label: "Pattern 1" },
                            { value: "Pattern 2", label: "Pattern 2" },
                            { value: "Pattern 3", label: "Pattern 3" },
                          ]}
                        />
                      </Space>
                    </div>
                  </div>
                  <hr></hr>
                  <div className="modal-table-container">
                    <div className="modal-table mt-4">
                      <table className="m-auto">
                        <thead>
                          <tr className="send-email-thead ">
                            <th>
                              <div className="px-3">Document Type</div>
                            </th>
                            <th>Group Name</th>
                            <th>Pattern Name</th>
                            <th>Pattern</th>
                            <th>Actions</th>
                          </tr>
                        </thead>
                        <tbody>
                          {campaigndata.map((data, index) => (
                            <tr key={data.id} className="send-email-tbody ">
                              <td first-td>
                                <div className="px-3">{data.doctype}</div>
                              </td>

                              <td>{data.groupname}</td>
                              <td>{data.pattername}</td>
                              <td>{data.pattern}</td>
                              <td className="last-td">
                                <Icon
                                  icon="heroicons:trash-20-solid"
                                  width={26}
                                  height={20}
                                  color="#181059"
                                />
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
                <div className="modal-btns-outer-div">
                  <div className="modal-bottom-btns h-center gap-2">
                    <button className="modal-dark-btn" onClick={handleCancel}>
                      Close
                    </button>
                    <button className="modal-dark-btn" onClick={handleOk}>
                      Update
                    </button>
                    <button className="modal-trans-btn">Reset</button>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </Modal>
      </div>
    </>
  );
};

export default EditdocpatternModal;
